<div cdkTrapFocus>
    <form matForm #loginDialog (ngSubmit)="save()">
        <h1 mat-dialog-title id="modal-title" class="mat-headline-1">{{activity}}</h1>
        <mat-dialog-content>
            <formly-form [model]='model' [fields]="fields" [form]="form" [options]="options"></formly-form>
        </mat-dialog-content>
    </form>
</div>